import { HDate, HHourInterval, HHourIntervals, HString, TimeZones } from '@shared/src/public-api';

export class MultiSlotInfoDto {

    public slotId: number;
    public onDate: HDate;
    public interval: HHourInterval;
    public intervalDock: HHourInterval;
    public intervalLift: HHourInterval;
    public addressTimetableIntervalId: number;
    public additionalInformation: string;
    public multiInterval: HHourIntervals;
    public multiIntervalDock: HHourIntervals;
    public multiIntervalLift: HHourIntervals;

    public timeZoneSlot: TimeZones;


    static toToolTipTextString(item: MultiSlotInfoDto): string {
        if (item == null)
            return "";
        let result = "";
      
        result += HString.concat(result, "", HDate.toGetString(item.onDate));
        result += HString.concat(result, " ", HHourIntervals.toScreenString(item.multiInterval));
        if (item.additionalInformation)
            result += HString.concat(result, " additionalInfo:", item.additionalInformation);
      
        return result;
    }
    static getAdditionalInformation(item: MultiSlotInfoDto): string {
        if (item == null)
            return "";
        return item.additionalInformation;
    }
    static toHourIntervalsString(item: MultiSlotInfoDto): string {
        if (item == null)
            return "";
        return HHourIntervals.toScreenString(item.multiInterval)
    }
}